'use strict';
module.exports = require('./Slider.vue');